<template>
  <v-container fluid class="country-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/country/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="countries-table"
              show-select
              single-select
              item-key="_id"
              sort-by="countryname"
              :footer-props="footer"
              :headers="headers"
              :items="countries"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Country?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteCountry.countryname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteCountry)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.countryname="{ item }">
                <p class="two-line"><strong>{{ item.countryname }}</strong></p>
                <p class="two-line">{{ item.countrynameinfo  }}</p>
              </template>
              <template v-slot:item.countryemail="{ item }">
                <a class="primaryConst--text">{{ item.countryemail }}</a>
              </template>
              <template v-slot:item.countryid="{ item }">
                {{ item.countryid }}
              </template>
              <template v-slot:item.company>
                Flatlogic
              </template>
              <template v-slot:item.countrystatus="{ item }">
                <v-chip
                  :color="!item.countrystatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.countrystatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'countryList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deleteCountry: {},
      headers: [
        { text: 'Type', value: 'countrytype' },
        { text: 'Name', value: 'countryname' },
        { text: 'Code', value: 'countrycode' },
        { text: 'Status', value: 'countrystatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      countryid: ['admin', 'country'],
    }
  },

  computed: {
    ...mapState('Country', ['countries', 'isReceiving', 'isDeleting', 'idToDelete', 'countriesMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit country'
    },
  },
  created () {
    this.getCountriesRequest()
  },
  methods: {
    ...mapActions('Country', ["getCountriesRequest","deleteCountryRequest","updateCountryRequest","createCountryRequest"]),
    editItem(item) {
      this.$router.push({ name: 'CountryEdit', params: item })
    },
    deleteItem(item) {
      this.deleteCountryRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteCountry = {
        _id: item._id,
        countryname: item.countryname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
